import styled from '@emotion/styled'
import { ReactNode } from 'react'
import { useInView } from 'react-intersection-observer'

import { useBreakpoints } from '@emico/ui'

import styles from './Sidebar.module.scss'

interface Props {
    children: ReactNode
}

const SubmitWrapper = styled.div`
    min-height: 41px;
    margin-top: 15px;
`

export const SidebarStickyButton = ({ children }: Props) => {
    const { isMobile, isTablet, isPortrait } = useBreakpoints()

    const [inViewRef, inView] = useInView({
        root: null,
        // The large top margin is to prevent the button to unsticky when we scroll past the bottom
        // of the cart page
        rootMargin: '9000px 0px -11px 0px',
        threshold: 1,
    })

    return (
        <SubmitWrapper ref={inViewRef}>
            <div
                className={
                    !inView && (isMobile || isTablet) ? styles.sticky : ''
                }
            >
                {children}
            </div>
        </SubmitWrapper>
    )
}
